<header class="topbar" style="background-color: #fff;">
  <div style="height: 35px; background: #003b30;">
    <div class="d-flex justify-content-end">
      <div class="p-2 bd-highlight">
        <a href="https://bit.ly/matricula-online-st" style=" color: #fff;" class="">
          <img src="./assets/images/icon/footer-icon-phone.svg" alt="">+562 2297 7278
        </a>
      </div>
      <div class="p-2 bd-highlight">
        <a href="https://www.tupuedes.cl/matricula-online/preguntas-frecuentes/" style=" color: #fff;" class="ml-1 ">
          <img src="./assets/images/icon/footer-icon-chat.svg" alt=""> Preguntas Frecuentes
        </a>
      </div>
      <div class="p-2 bd-highlight">
        <a href="https://www.tupuedes.cl/contacto/" style=" color: #fff;" class="ml-1">
          <img src="./assets/images/icon/footer-icon-mail.svg" alt=""> Formulario de Contacto
        </a>
      </div>
    </div>


  </div>
  <nav class="navbar top-navbar navbar-expand-md navbar-light">
    <!-- ============================================================== -->
    <!-- Logo -->
    <!-- ============================================================== -->
    <div class="navbar-header">
      <img class="elastic-img cover logo-down"
        src="https://www.tupuedes.cl/wp-content/themes/admision/images/logos/logo-ust-horizontal.svg" width="195"
        height="39" alt="www.tupuedes.cl">
    </div>
    <!-- ============================================================== -->
    <!-- End Logo -->
    <!-- ============================================================== -->
    <div class="navbar-collapse">
      <!-- ============================================================== -->
      <!-- toggle and nav items -->
      <!-- ============================================================== -->
      <ul class="navbar-nav mr-auto">

      </ul>
      <!-- ============================================================== -->
      <!-- User profile and search -->
      <!-- ============================================================== -->
      <ul class="navbar-nav my-lg-0">



        <!-- ============================================================== -->
        <!-- Profile -->
        <!-- ============================================================== -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false"><img src="../assets/images/user.png" alt="user"
              class="profile-pic" /></a>
          <div class="dropdown-menu dropdown-menu-right animated flipInY">
            <ul class="dropdown-user">
              <li>
                <div class="dw-user-box">
                  <div class="u-img"><img src="../assets/images/user.png" alt="user"></div>
                  <div class="u-text">
                    <h4>{{Nombre}}</h4>
                    <p class="text-muted">{{correo}}</p>
                  </div>
                </div>
              </li>
              <li role="separator" class="divider"></li>
              <li><a style="cursor: pointer;" (click)="salir()"><em class="fa fa-power-off"></em> Salir</a></li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>